import { useMsal } from '@azure/msal-react';

export interface ExplorerLabAccountLike {
  name?: string | null;
  username?: string | null;
}

export function isExplorerLabAllowedAccount(account: ExplorerLabAccountLike | null | undefined): boolean {
  const identityValues = [account?.name, account?.username]
    .filter((value): value is string => typeof value === 'string' && value.trim().length > 0)
    .map((value) => value.toLowerCase());

  return identityValues.some((value) => value.includes('amerrick'));
}

export function useCanAccessExplorerLab(): boolean {
  const { accounts, instance } = useMsal();

  return isExplorerLabAllowedAccount(instance.getActiveAccount() ?? accounts[0] ?? null);
}